import { render, staticRenderFns } from "./viewTax.vue?vue&type=template&id=5aca0866&scoped=true&"
import script from "./viewTax.vue?vue&type=script&lang=js&"
export * from "./viewTax.vue?vue&type=script&lang=js&"
import style0 from "./viewTax.vue?vue&type=style&index=0&id=5aca0866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aca0866",
  null
  
)

export default component.exports